import React, { useState } from 'react'
import { checkIfEmailIsInternal } from '../../../../global/authentication/authentication-manager.js'
import { setItem } from '../../../../global/data/synch-storage.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import InputGroup from '../../../EmailSubscriptionCenter/SignIn/InputGroup.jsx'
import { FORM_NAME_CHALLENGE_CHOICE } from '../../../Login/Helpers/LoginHelper.js'
import { postForgotPassword } from '../../../SelfService/Data/SelfServiceDataSource.js'
import FormNotification from '../../../SelfService/FormNotification.jsx'

function UserIdForm({ userIdHook, handleDisplayChange }) {
  const [userId, setUserId] = userIdHook
  const [formValidation, setFormValidation] = useState({
    'login-user-id': {
      error: false,
      errorMessage: 'Enter your firm email address',
    },
  })
  const [formErrorMessage, setFormErrorMessage] = useState('')
  const [formWarningMessage, setFormWarningMessage] = useState('')

  const onContinueClicked = async () => {
    if (!userId) {
      const _formValidation = { ...formValidation }
      _formValidation['login-user-id'].error = true
      setFormValidation(_formValidation)
    }
    if (checkIfEmailIsInternal(userId)) {
      const message =
        'Your password for this site is your SSO and workstation password. Change your password through your Ameriprise workstation login by selecting CTRL+ALT+DEL, and then "Change Password." This will ensure your SSO and workstation passwords will be synchronized.'
      setFormWarningMessage(message)
      // validateUsername()
      // return
    } else {
      const _formValidation = { ...formValidation }
      _formValidation['login-user-id'].error = false
      setFormValidation(_formValidation)

      const forotPasswordRequestData = {
        id: userId,
        idContext: 'USERID',
        deviceSignature: window?.getDeviceSignature(),
      }

      const response = await postForgotPassword(forotPasswordRequestData)
      let data = null

      const responseText = await response.text()
      if (responseText) {
        data = JSON.parse(responseText)
      }

      if (data && !data.error) {
        const apiToken = response.headers.get('apitoken')
        setItem('apiToken', apiToken)
        handleDisplayChange(FORM_NAME_CHALLENGE_CHOICE, data)
      } else if (data.error && data.error.details) {
        switch (data.error.details.code) {
          case 'CTN_FORGOTPASSWORD_1112':
          case 'CTN_FORGOTPASSWORD_1114':
          case 'CTN_FORGOTPASSWORD_1116':
            setFormErrorMessage(
              "For your protection, your account has been locked because you did not enter your passcode correctly. To unlock your account, please <a href='/about-us/contact-us/'>contact a Columbia Threadneedle</a> representative at <a href='tel:8002482828'>800.248.2828</a> for assistance."
            )
            break
          case 'CTN_FORGOTPASSWORD_0001':
          case 'CTN_FORGOTPASSWORD_0002':
            showDefaultErrorMessage()
            break
          case 'CTN_FORGOTPASSWORD_0005':
            setFormErrorMessage(
              "Unfortunately, your guest access has expired because we've determined you are not eligible for site access. Please call a Columbia Threadneedle representative at <a href='tel:8002482828'>800.248.2828</a> for assistance."
            )
            break
          case 'CTN_FORGOTPASSWORD_1115':
            setFormErrorMessage(
              "Unfortunately, your guest access to this site has expired, because we were unable to validate your registration information. Please call a Columbia Threadneedle representative at <a href='tel:8002482828'>800.248.2828</a> for assistance."
            )
            break
          default:
            showDefaultErrorMessage()
        }
      } else {
        showDefaultErrorMessage()
      }
    }
  }

  const showDefaultErrorMessage = () => {
    setFormErrorMessage(
      "A problem occured with your account. Please call us at <a href='tel:8002482828'>800.248.2828</a> or check your email for further instruction."
    )
  }

  const onCancelClicked = () => {
    window.location.href = getRelativeBasePath() + '/login'
  }

  const onChangeUserId = (event) => {
    setUserId(event.target.value)
  }

  return (
    <div
      className="Card Content u-padding6gu u-marginVert10gu u-bgColorLightest"
      data-analytics-login-step="User Id"
    >
      <div className="Grid">
        <div className="u-sizeFull u-lg-size5of12 u-lg-after1of12 Content">
          <h2 className="u-marginTop0 u-marginBottom4gu">Enter your User Id</h2>
          {formWarningMessage && (
            <FormNotification content={formWarningMessage} status="warn" />
          )}
          {formErrorMessage && (
            <FormNotification
              content={formErrorMessage}
              status="warn"
              isHtml={true}
            />
          )}
          <InputGroup
            handleInputChange={onChangeUserId}
            formValidation={formValidation}
            fieldName="login-user-id"
            fieldId="login-user-id"
            placeholder="Firm Email Address or SSO User ID"
            label="User ID"
            compact={false}
            disabled={false}
          />
          <div className="Grid Grid--withGutter">
            <div className="u-size6of12">
              <button
                onClick={onContinueClicked}
                className="Button Button--primary Button--block u-marginRight5gu u-marginBottom3gu u-paddingHoriz8gu u-textNoTransform"
              >
                Continue
              </button>
            </div>
            <div className="u-size6of12">
              <button
                onClick={onCancelClicked}
                className="Button Button--primary Button--reversed Button--block u-paddingHoriz8gu"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

UserIdForm.propTypes = {}

export default UserIdForm
